import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import noDataImage from 'assets/images/nodataGreen.png';

export const ImageContainer = styled.div`
	margin-top: 22px;
	background-image: url(${noDataImage});
	background-repeat: no-repeat;
	background-size: contain;
	min-height: 372px;
	min-width: 441px;
`;

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Title = styled.div`
	font-size: 33px;
	font-weight: 500;
	line-height: 41px;
	letter-spacing: 0.3px;
	text-align: center;

	position: relative;
	top: -20px;
	color: ${colors.grey8};
`;

export const Text = styled.div`
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: 0px;
	text-align: center;

	padding-top: 5px;
	margin-bottom: 24px;
	color: ${colors.grey5};
`;
